module.exports = __webpack_public_path__ + "static/media/dj.0b3d1b91.svg";